


import { useContext, useEffect, useMemo, useState } from "react";
import {
  ListItemText,
  Skeleton,
  styled,
  Switch,
  Typography,
} from "@mui/material";
import {
  fetchCustomerLlms,
  getGeographies,
  getLlms,
  getMarkets,
  getCustomerMonitoringFiletrs,
  getCustomerMonitoringDates,
} from "../../services/apiService";
import classes from "./LLMReporting.module.css";
import { AuthContext } from "../../context/auth-context";
import { toast, ToastContainer } from "react-toastify";
import DashboardNav from "../Dashboard/common/DashboardNav";
import { useDispatch, useSelector } from "react-redux";
import React from "react";
import { fetchBrandProducts } from "../../redux/actions/brandProductsActions";
import { fetchBrands } from "../../redux/actions/brandsActions";
import api from "../../BrandOnBoarding/api";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import LinearProgress, {
  linearProgressClasses,
} from "@mui/material/LinearProgress";
import { initialBrandTabs } from "./brand_data";
import { initialProdTabs } from "./prod_data";
import { Spinner } from "react-bootstrap";
import { handleInputValidation } from "../../utils/monitoring-helpers";
import { MONITORING_LLM_LABELS } from "../../utils/constant";

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 10,
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: theme.palette.grey[200],
    ...theme.applyStyles("dark", {
      backgroundColor: theme.palette.grey[800],
    }),
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: "#1a90ff",
    ...theme.applyStyles("dark", {
      backgroundColor: "#308fe8",
    }),
  },
}));

export default function LLMReporting() {
  const dispatch = useDispatch();
  const [selectedOptionShow, setSelectedOptionShow] = useState("Company/Brand"); //"Product"
  const [brandItems, setBrandItems] = useState([]);
  const [selectedBrandItems, setSelectedBrandItems] = useState([]);
  const [selectedProductItems, setSelectedProductItems] = useState([]);
  const [personas, setPersonas] = useState([]);
  const [selectedPersona, setSelectedPersona] = useState([]);
  const [productItems, setProductItems] = useState([]);
  const [inputValidation, setInputValidation] = useState({
    selectedProductItems: false,
    selectedBrandItems: false,
    selectedPersona: false,
    selectedGeographyItems: false,
    selectedMarketItems: false,
    selectedLlmItems: false,
  });
  const [isFirstTime, setIsFirstTime] = useState(true);
  const [showData, setShowData] = useState(false);
  const [isDone, setIsDone] = useState(true);
  const [selectedLlmItems, setSelectedLlmItems] = useState([]);
  const [customerLlm, setCustomerLlm] = useState([]);
  const [selectedMarketItems, setSelectedMarketItems] = useState([]);
  const [selectedGeographyItems, setSelectedGeographyItems] = useState([]);
  const [dbLlms, setDbLlms] = useState([]);
  const [geography, setGeography] = useState([]);
  const [markets, setMarkets] = useState([]);
  const [activeSequence, setActiveSequence] = useState(initialBrandTabs);
  const [isLoading, setLoading] = useState(false);
  const { user } = useContext(AuthContext);
  const customerId = user?.customer_id || 0;
  const brandProducts = useSelector((state) => state.brandProducts);
  const brands = useSelector((state) => state.brands);
  const isCompanyUser = user?.user_role?.role?.name === "Company user"
  const [selectedSubFrequencyItems, setSelectedSubFrequencyItems] =
    useState("Current");
  const [percentCompleted, setPercentCompleted] = useState(0);
   // Nav tabs (optional: you can keep it fixed as "overview")
     const [activeTab, setActiveTab] = useState("overview");
   const handleTabClick = (tab) => setActiveTab(tab);


   // Category lists & selection
     const [categories, setCategories] = useState([]);
   const [selectedCategory, setSelectedCategory] = useState([]);
   const [selectedCategoryIds, setSelectedCategoryIds] = useState([]);

   // Dates (for DateRangePicker in DashboardNav)
     const [startDate, setStartDate] = useState(null);
   const [endDate, setEndDate] = useState(null);
   const [availableDates, setAvailableDates] = useState([]);
   const [customDatesToDisplay, setCustomDatesToDisplay] = useState(null);

   // Filter modal (wire up later as needed)
     const [showFilterModal, setShowFilterModal] = useState(false);
   const [filterModalType, setFilterModalType] = useState("NA");
   const [isFilterActive, setIsFilterActive] = useState(false);
   const [monitoringFiletrs, setMonitoringFilters] = useState();
   const [customDateFilter, setCustomDateFilter] = useState('Recent')
   const [isChecked, setIsChecked] = useState(false);


       const [isFilterQuery, setIsFilterQuery] = useState(false);
       const [selectedFrequencyItems, setSelectedFrequencyItems] = useState([
           "Daily",
         ]);

                 const [value, setValue] = useState(0);

                   
         


  // useEffect(() => {
  //   setInputValidation({
  //     selectedProductItems: !!selectedProductItems.length,
  //     selectedBrandItems: !!selectedBrandItems.length,
  //     selectedPersona: !!selectedPersona.length,
  //     selectedGeographyItems: !!selectedGeographyItems.length,
  //     selectedMarketItems: !!selectedMarketItems.length,
  //     selectedLlmItems: selectedLlmItems.some((v) => v !== undefined),
  //     selectedCategory: !!selectedCategory.length,
  //   });
  // }, [
  //   selectedProductItems,
  //   selectedBrandItems,
  //   selectedPersona,
  //   selectedGeographyItems,
  //   selectedMarketItems,
  //   selectedLlmItems,
  //   selectedCategory,
  //   selectedOptionShow,
  // ]);

 useEffect(() => {
   const isNonEmpty = (v) => Array.isArray(v) && v.length > 0 && v.some((a) => a !== undefined);

   const inputVal = {
     // require exactly one of brand or product depending on the active tab
     selectedBrandItems: selectedOptionShow === "Company/Brand"
       ? isNonEmpty(selectedBrandItems)
       : true,
     selectedProductItems: selectedOptionShow === "Product"
       ? isNonEmpty(selectedProductItems)
       : true,

     // these must be chosen regardless of tab
     selectedCategory: isNonEmpty(selectedCategory),
     selectedGeographyItems: isNonEmpty(selectedGeographyItems),
     selectedMarketItems: isNonEmpty(selectedMarketItems),
     selectedPersona: isNonEmpty(selectedPersona),
     selectedLlmItems: isNonEmpty(selectedLlmItems),
   };

   setInputValidation(inputVal);
 }, [
   selectedProductItems,
     selectedBrandItems,
     selectedPersona,
     selectedGeographyItems,
     selectedMarketItems,
     selectedLlmItems,
     selectedCategory,
     selectedOptionShow,
 ])

  const isReady = () => Object.values(inputValidation).every(Boolean);
  console.log("isReady== ", isReady());


  useEffect(() => {
    async function fetchData() {
      const selectedBrandCustomerId = customerId;
      const customerSpecificLlms = await fetchCustomerLlms([
        Number(selectedBrandCustomerId),
      ]);

      setCustomerLlm(customerSpecificLlms?.data);
      const inputFilters = await getCustomerMonitoringFiletrs(customerId);

      let filters = {
        ...inputFilters,
        brands: [...(inputFilters?.brands || [])],
        products: [...(inputFilters?.products || [])],
      };

      setMonitoringFilters(filters);

      const newBrandItems = filters?.brands?.map((item) => {
        return { id: item?.customer_brand_id, name: item?.brand_name };
      });

      setBrandItems((prevItems) => [...newBrandItems]);
      // auto-pick first brand so the cascade can run
      if (!selectedBrandItems.length && newBrandItems?.length) {
        // setSelectedOptionShow("Company/Brand");
        setSelectedBrandItems([newBrandItems[0].name]);
      }

      const newProductItems = filters?.products?.map((item) => {
        return { id: item?.customer_brand_product_id, name: item?.product_name };
      }) || [];
      setProductItems((prev) => [...newProductItems]);
       if (selectedOptionShow === "Product" && !selectedProductItems.length && newProductItems.length) {
           setSelectedProductItems([newProductItems[0].name]);
         }

      // set the customer geographies
      let geo = await getGeographies();
      const geographyIds = [
        ...new Set(customerSpecificLlms?.data.map((obj) => obj?.geography_id)),
      ];
      geo = geo?.data.filter((obj) => geographyIds.includes(obj?.id));
      setGeography(geo);

      // set customer geography markets

      let market = await getMarkets();
      const filtercustomeLlm = customerSpecificLlms?.data.filter(
        (obj) => obj?.geography_id === 1
      );
      const marketIds = [
        ...new Set(filtercustomeLlm.map((obj) => obj?.market_id)),
      ];
      market = market?.data.filter((obj) => marketIds.includes(obj?.id));
      setMarkets(market);

      if (brandProducts?.data && brandProducts?.data.length === 0) {
        dispatch(fetchBrandProducts(customerId));
      }

      if (brands?.data && brands?.data.length === 0) {
        dispatch(fetchBrands(customerId));
      }

      // const llms = await getLlms();
      // setDbLlms(llms?.data);
    }

    fetchData();
  }, []);


  // ----- helpers to mirror Dashboard.js derivation -----
    const productSpec = {
 root: () => monitoringFiletrs?.products,
      key: "product_name",
        defaultGeoField: "customer_product_geo",
        };
const brandSpec = {
root: () => monitoringFiletrs?.brands,
    key: "brand_name",
      defaultGeoField: "customer_brand_geo",
      };
const pickEntity = (spec, selectedNames) => {
    const root = spec.root() || [];
    return root.find((item) => selectedNames?.includes(item?.[spec.key]));
  };
const categoryListFrom = (entity) =>
    entity?.categories?.map((c) => ({ id: c?.categoryId, name: c?.categoryName })) ?? [];
const deriveByCategory = (entity, categoryName) => {
    const cat = entity?.categories?.find((c) => c?.categoryName === categoryName);
    return {
 geography: cat?.geographies ?? [],
        markets: cat?.markets ?? [],
          persona: cat?.personas ?? [],
            llms: cat?.llms ?? [],
            };
};

  const currentSpec = useMemo(() => {
    const useProduct = selectedOptionShow === "Product" && selectedProductItems?.length > 0;
    return useProduct ? productSpec : brandSpec;
  }, [selectedOptionShow, selectedProductItems, selectedBrandItems]);

  const currentEntity = useMemo(() => {
    if (!monitoringFiletrs) return null;
    const useProduct = selectedOptionShow === "Product" && selectedProductItems?.length > 0;
    const selectedNames = useProduct ? selectedProductItems : selectedBrandItems;
    return pickEntity(currentSpec, selectedNames);
  }, [monitoringFiletrs, selectedOptionShow, selectedProductItems, selectedBrandItems, currentSpec]);

  const categoriesForEntity = useMemo(() => {
    if (!currentEntity) return [];
    return categoryListFrom(currentEntity);
  }, [currentEntity]);

  useEffect(() => {
    if (!monitoringFiletrs || !currentEntity) return;

    // 1) categories
    const cats = categoriesForEntity;
    setCategories(cats);

    // preserve prior category if still valid, else first
    const prevCategoryName = selectedCategory?.[0];
    const hasPrev = cats?.some(c => c.name === prevCategoryName);
    const nextCatName = hasPrev ? prevCategoryName : cats?.[0]?.name;
    const nextCatId = hasPrev ? selectedCategoryIds?.[0] : cats?.[0]?.id;

    if (nextCatName) setSelectedCategory([nextCatName]);
    if (nextCatId) setSelectedCategoryIds([nextCatId]);

    // 2) derive lists under that category
    const { geography: geo, markets: mkts, persona: ppl, llms } = deriveByCategory(currentEntity, nextCatName);
    setDbLlms(llms || []);
    setGeography(geo || []);
    setMarkets(mkts || []);
    setPersonas(ppl || []);

    // 3) sensible fallbacks that keep previous when still valid
    const defaultGeoObj = currentEntity?.[currentSpec.defaultGeoField];

    setSelectedLlmItems(prev => {
      const p = prev?.[0];
      const ok = (llms || []).some(x => x?.name === p);
      const fb = (llms || [])[0]?.name || "gpt-4o";
      return [ok ? p : fb].filter(Boolean);
    });

    setSelectedMarketItems(prev => {
      const p = prev?.[0];
      const ok = (mkts || []).some(x => x?.name === p);
      const fb = (mkts || [])[0]?.name;
      return [ok ? p : fb].filter(Boolean);
    });

    setSelectedGeographyItems(prev => {
      const p = prev?.[0];
      if ((geo || []).some(g => g?.name === p)) return [p];
      const fb = (geo || []).some(g => g?.name === defaultGeoObj?.name)
        ? defaultGeoObj?.name
        : (geo || [])[0]?.name;
      return [fb].filter(Boolean);
    });

    setSelectedPersona(prev => {
      const p = prev?.[0] ?? "General Persona";
      const ok = (ppl || []).some(x => x?.name === p);
      const fb = (ppl || [])[0]?.name;
      return [ok ? p : fb].filter(Boolean);
    });
    setTimeout(() => {
              setIsFirstTime(false);

              }, 3000);
  }, [
    monitoringFiletrs,
    currentEntity,
    categoriesForEntity,
    currentSpec,
  ]);
  


  // useEffect(() => {
  //   if (!monitoringFiletrs) return;

  //   const useProduct = selectedOptionShow === "Product" && selectedProductItems?.length > 0;
  //   const useBrand = selectedOptionShow === "Company/Brand" && selectedBrandItems?.length > 0;
  //   if (!useProduct && !useBrand) return;

  //   const spec = useProduct ? productSpec : brandSpec;
  //   const selectedNames = useProduct ? selectedProductItems : selectedBrandItems;
  //   const entity = pickEntity(spec, selectedNames);
  //   if (!entity) return;

  //   // 1) categories
  //   const cats = categoryListFrom(entity);
  //   setCategories(cats);

  //   // preserve prior category if still valid, else first
  //   const prevCategoryName = selectedCategory?.[0];
  //   const hasPrev = cats?.some(c => c.name === prevCategoryName);
  //   const nextCatName = hasPrev ? prevCategoryName : cats?.[0]?.name;
  //   const nextCatId = hasPrev ? selectedCategoryIds?.[0] : cats?.[0]?.id;
  //   if (nextCatName) setSelectedCategory([nextCatName]);
  //   if (nextCatId) setSelectedCategoryIds([nextCatId]);

  //   // 2) derive lists under that category
  //   const { geography: geo, markets: mkts, persona: ppl, llms } = deriveByCategory(entity, nextCatName);
  //   setDbLlms(llms || []);
  //   setGeography(geo || []);
  //   setMarkets(mkts || []);
  //   setPersonas(ppl || []);

  //   // 3) sensible fallbacks that keep previous when still valid
  //   const defaultGeoObj = entity?.[spec.defaultGeoField];

  //   setSelectedLlmItems(prev => {
  //     const p = prev?.[0];
  //     const ok = (llms || []).some(x => x?.name === p);
  //     const fb = (llms || [])[0]?.name || "gpt-4o";
  //     return [ok ? p : fb];
  //   });

  //   setSelectedMarketItems(prev => {
  //     const p = prev?.[0];
  //     const ok = (mkts || []).some(x => x?.name === p);
  //     const fb = (mkts || [])[0]?.name;
  //     return [ok ? p : fb];
  //   });

  //   setSelectedGeographyItems(prev => {
  //     const p = prev?.[0];
  //     if ((geo || []).some(g => g?.name === p)) return [p];
  //     const fb = (geo || []).some(g => g?.name === defaultGeoObj?.name)
  //       ? defaultGeoObj?.name
  //       : (geo || [])[0]?.name;
  //     return [fb];
  //   });

  //   setSelectedPersona(prev => {
  //     const p = prev?.[0] ?? "General Persona";
  //     const ok = (ppl || []).some(x => x?.name === p);
  //     const fb = (ppl || [])[0]?.name;
  //     return [ok ? p : fb];
  //   });
  // }, [
  //   monitoringFiletrs,
  //   selectedOptionShow,
  //   selectedProductItems,
  //   selectedBrandItems,
  // ]);

  useEffect(() => {
    if (!monitoringFiletrs || !selectedCategory?.length) return;

    const useProduct = selectedOptionShow === "Product" && selectedProductItems?.length > 0;
    const spec = useProduct ? productSpec : brandSpec;
    const names = useProduct ? selectedProductItems : selectedBrandItems;
    const entity = pickEntity(spec, names);
    if (!entity) return;

    const catName = selectedCategory[0];
    const { geography: geo, markets: mkts, persona: ppl, llms } = deriveByCategory(entity, catName);

    setDbLlms(llms || []);
    setGeography(geo || []);
    setMarkets(mkts || []);
    setPersonas(ppl || []);

    const defaultGeoObj = entity?.[spec.defaultGeoField];

    // same keep-or-fallback logic as above...
    // (setSelectedLlmItems / setSelectedMarketItems / setSelectedGeographyItems / setSelectedPersona)
    setSelectedLlmItems(prev => {
      const p = prev?.[0];
      const ok = (llms || []).some(x => x?.name === p);
      const fb = (llms || [])[0]?.name || "gpt-4o";
      return [ok ? p : fb];
    });

    setSelectedMarketItems(prev => {
      const p = prev?.[0];
      const ok = (mkts || []).some(x => x?.name === p);
      const fb = (mkts || [])[0]?.name;
      return [ok ? p : fb];
    });

    setSelectedGeographyItems(prev => {
      const p = prev?.[0];
      if ((geo || []).some(g => g?.name === p)) return [p];
      const fb = (geo || []).some(g => g?.name === defaultGeoObj?.name)
        ? defaultGeoObj?.name
        : (geo || [])[0]?.name;
      return [fb];
    });

    setSelectedPersona(prev => {
      const p = prev?.[0] ?? "General Persona";
      const ok = (ppl || []).some(x => x?.name === p);
      const fb = (ppl || [])[0]?.name;
      return [ok ? p : fb];
    });
  }, [selectedCategory]);

  // const isReady =
  //   !!selectedOptionShow &&
  //   !!(selectedBrandItems?.length || selectedProductItems?.length) &&
  //   !!selectedCategory?.[0] &&
  //   !!selectedGeographyItems?.[0] &&
  //   !!selectedMarketItems?.[0] &&
  //   !!selectedPersona?.[0] &&
  //   !!selectedLlmItems?.[0];

  // useEffect(() => { setIsFirstTime(isReady); }, [isReady]);
  
  

    // useEffect(() => {
    //     if (!monitoringFiletrs) return;
    
    //       const useProduct =
    //           selectedOptionShow === "Product" && selectedProductItems?.length > 0;
    //     const useBrand =
    //         selectedOptionShow === "Company/Brand" && selectedBrandItems?.length > 0;
    //     if (!useProduct && !useBrand) return;
    
    //       const spec = useProduct ? productSpec : brandSpec;
    //     const selectedNames = useProduct ? selectedProductItems : selectedBrandItems;
    //     const entity = pickEntity(spec, selectedNames);
    //     if (!entity) return;
    
    //       // categories
    //       const cats = categoryListFrom(entity);
    //     setCategories(cats);
    
    //       // keep previous category if still valid, else take first
    //       const prevCategoryName = selectedCategory?.[0];
    //     const hasPrevCategory = cats?.some((c) => c.name === prevCategoryName);
    //     const nextCategoryName = hasPrevCategory ? prevCategoryName : cats?.[0]?.name;
    //     const nextCategoryId = hasPrevCategory
    //         ? selectedCategoryIds?.[0]
    //       : cats?.[0]?.id;
    //     if (nextCategoryName) setSelectedCategory([nextCategoryName]);
    //     if (nextCategoryId) setSelectedCategoryIds([nextCategoryId]);
    
    //       // derive geographies/markets/personas/llms from category
    //       const { geography: geo, markets: mkts, persona: ppl, llms } =
    //           deriveByCategory(entity, nextCategoryName);
    
    //       setDbLlms(llms || []);
    //     setGeography(geo || []);
    //     setMarkets(mkts || []);
    //     setPersonas(ppl || []);
    
    //       // fallbacks that preserve previous valid selections
    //       const defaultGeoObj = entity?.[spec.defaultGeoField];
    
    //       setSelectedLlmItems((prev) => {
    //           const prevName = prev?.[0];
    //           const ok = (llms || []).some((x) => x?.name === prevName);
    //           const fallback = (llms || [])[0]?.name || "gpt-4o";
    //           return [ok ? prevName : fallback];
    //         });
    
    //       setSelectedMarketItems((prev) => {
    //           const prevName = prev?.[0];
    //           const ok = (mkts || []).some((x) => x?.name === prevName);
    //           const fallback = (mkts || [])[0]?.name;
    //           return [ok ? prevName : fallback];
    //         });
    
    //       setSelectedGeographyItems((prev) => {
    //           const prevName = prev?.[0];
    //           if ((geo || []).some((g) => g?.name === prevName)) return [prevName];
    //           const fall =
    //               (geo || []).some((g) => g?.name === defaultGeoObj?.name)
    //                   ? defaultGeoObj?.name
    //                 : (geo || [])[0]?.name;
    //           return [fall];
    //         });
    
    //       setSelectedPersona((prev) => {
    //           // const prevName = prev?.[0];
    //           const prevName = 'General Persona'
    //           const ok = (ppl || []).some((x) => x?.name === prevName);
    //           const fallback = (ppl || [])[0]?.name;
    //           return [ok ? prevName : fallback];
    //         });
    //         setTimeout(() => {
    //           setIsFirstTime(false);
              
    //         }, 3000);
    //   }, [
    //     monitoringFiletrs,
    //     selectedOptionShow,
    //     selectedProductItems,
    //     selectedBrandItems,
    //   ]);
    

  // useEffect(() => {
  //     async function fetchCustomerLlmsData() {
  //       if (
  //         // !isFirstTime &&
  //         // !isFilterQuery &&
  //         selectedBrandItems &&
  //         selectedBrandItems.length > 0
  //       ) {
  //         if (selectedOptionShow === "Company/Brand") {
  //           const defaultGeography = monitoringFiletrs?.brands?.filter((item) =>
  //             selectedBrandItems.includes(item?.brand_name)
  //           )?.[0]?.customer_brand_geo
  //           const geography = monitoringFiletrs?.brands?.filter((item) =>
  //             selectedBrandItems.includes(item?.brand_name)
  //           )?.[0]?.categories?.[0]?.geographies;
  //           const markets = monitoringFiletrs?.brands?.filter((item) =>
  //             selectedBrandItems.includes(item?.brand_name)
  //           )?.[0]?.categories?.[0]?.markets;
  //           const persona = monitoringFiletrs?.brands?.filter((item) =>
  //             selectedBrandItems.includes(item?.brand_name)
  //           )?.[0]?.categories?.[0]?.personas;
  //           const llms = monitoringFiletrs?.brands?.filter((item) =>
  //             selectedBrandItems.includes(item?.brand_name)
  //           )?.[0]?.categories?.[0]?.llms;
  //           const category = monitoringFiletrs?.brands
  //             ?.filter((item) =>
  //               selectedBrandItems?.includes(item?.brand_name)
  //             )?.[0]
  //             ?.categories?.map((item) => {
  //               return { id: item?.categoryId, name: item?.categoryName };
  //             });
  //           const categoryIds = [category?.[0]?.id] || null;
  
  //           setDbLlms(llms);
  //           setGeography(geography);
  //           setMarkets(markets);
  //           setPersonas(persona);
  //           setCategories(category);
  //           setSelectedLlmItems(prevSelected => {
  //             const selectedName = prevSelected?.[0];
  //             const existsInLlms = llms?.some(p => p.name === selectedName);
  //             const newName = existsInLlms && !isFirstTime ? selectedName : "gpt-4o";
  //             return [newName]
  //           });
  //           setSelectedMarketItems(prevSelected => {
  //             const selectedName = prevSelected?.[0];
  //             const existsInMarkets = markets?.some(p => p.name === selectedName);
  //             const newName = existsInMarkets ? selectedName : markets?.[0]?.name;
  //             return [newName];
  //           });
  //           setSelectedGeographyItems(prevSelected => {
  //             const selectedName = prevSelected?.[0];
  
  //             if (geography?.some(g => g.name === selectedName)) {
  //               return [selectedName];
  //             }
  
  //             const fallbackName = geography?.some(g => g.name === defaultGeography?.name)
  //               ? defaultGeography?.name
  //               : geography?.[0]?.name;
  
  //             return [fallbackName];
  //           });

  //           const generalPersona = persona?.find(p => p.name === "General Persona");
            
  //             setSelectedPersona(prevSelected => {
  //               const selectedName = prevSelected?.[0];
  //               const existsInPersona = persona?.some(p => p.name === selectedName);
  //               const newName = existsInPersona ? selectedName : generalPersona?.name;
  //               return [newName];
  //             });
            
  //           setSelectedCategory(prevSelected => {
  //             const selectedName = prevSelected?.[0];
  //             const existsInCategory = category?.some(p => p.name === selectedName);
  //             const newName = existsInCategory ? selectedName : category?.[0]?.name;
  //             return [newName];
  //           });
  //           setSelectedCategoryIds(prevSelected => {
  //             const selectedId = prevSelected?.[0];
  //             const existsInCategoryId = category?.some(p => p.id === selectedId);
  //             const newId = existsInCategoryId ? selectedId : category?.[0]?.id;
  //             return [newId];
  //           });
  //         }
  //       }
  //     }
  
  //     fetchCustomerLlmsData();
  // }, [selectedBrandItems]);

    // useEffect(() => {
    //     async function fetchCustomerLlmsData() {
    //       if (
    //         // !isFirstTime &&
    //         // !isFilterQuery &&
    //         selectedProductItems &&
    //         selectedProductItems.length > 0
    //       ) {
    //         if (selectedOptionShow === "Product") {
    //           const defaultGeography = monitoringFiletrs?.products?.filter((item) =>
    //             selectedProductItems.includes(item?.product_name)
    //           )?.[0]?.customer_product_geo
    //           const geography = monitoringFiletrs?.products
    //             ?.filter((item) =>
    //               selectedProductItems.includes(item?.product_name)
    //             )?.[0]
    //             ?.categories?.filter((item) =>
    //               selectedCategory?.includes(item?.categoryName)
    //             )?.[0]?.geographies;
    //           const markets = monitoringFiletrs?.products
    //             ?.filter((item) =>
    //               selectedProductItems.includes(item?.product_name)
    //             )?.[0]
    //             ?.categories?.filter((item) =>
    //               selectedCategory?.includes(item?.categoryName)
    //             )?.[0]?.markets;
    //           const persona = monitoringFiletrs?.products
    //             ?.filter((item) =>
    //               selectedProductItems.includes(item?.product_name)
    //             )?.[0]
    //             ?.categories?.filter((item) =>
    //               selectedCategory?.includes(item?.categoryName)
    //             )?.[0]?.personas;
    //           const llms = monitoringFiletrs?.products
    //             ?.filter((item) =>
    //               selectedProductItems.includes(item?.product_name)
    //             )?.[0]
    //             ?.categories?.filter((item) =>
    //               selectedCategory?.includes(item?.categoryName)
    //             )?.[0]?.llms;
    //           const category = monitoringFiletrs?.products
    //             ?.filter((item) =>
    //               selectedProductItems?.includes(item?.product_name)
    //             )?.[0]
    //             ?.categories?.map((item) => {
    //               return { id: item?.categoryId, name: item?.categoryName };
    //             });
    //           const categoryIds = [category?.[0]?.id] || null;
    //           setDbLlms(llms);
    //           setGeography(geography);
    //           setMarkets(markets);
    //           setPersonas(persona);
    //           setCategories(category);
    //           // setSelectedLlmItems(['gpt-4o']);
    //           // setSelectedMarketItems([markets?.[0]?.name]);
    //           setSelectedLlmItems(prevSelected => {
    //             const selectedName = prevSelected?.[0];
    //             const existsInLlms = llms?.some(p => p.name === selectedName);
    //             const newName = existsInLlms ? selectedName : "gpt-4o";
    //             return [newName]
    //           });
    //           setSelectedMarketItems(prevSelected => {
    //             const selectedName = prevSelected?.[0];
    //             const existsInMarkets = markets?.some(p => p.name === selectedName);
    //             const newName = existsInMarkets ? selectedName : markets?.[0]?.name;
    //             return [newName];
    //           });
    //           // setSelectedGeographyItems([geography?.some(obj => obj.name === defaultGeography?.name) ? defaultGeography?.name : geography?.[0]?.name]);
    //           setSelectedGeographyItems(prevSelected => {
    //             const selectedName = prevSelected?.[0];
    
    //             if (geography?.some(g => g.name === selectedName)) {
    //               return [selectedName];
    //             }
    
    //             const fallbackName = geography?.some(g => g.name === defaultGeography?.name)
    //               ? defaultGeography?.name
    //               : geography?.[0]?.name;
    
    //             return [fallbackName];
    //           });
    
    //           setSelectedPersona(prevSelected => {
    //             const selectedName = prevSelected?.[0];
    //             const existsInPersona = persona?.some(p => p.name === selectedName);
    //             const newName = existsInPersona ? selectedName : persona?.[0]?.name;
    //             return [newName];
    //           });
    
    //           const isCategoryTab = activeTab === "category";
    //           if (isCategoryTab) {
    //             setSelectedCategory(category.map((obj) => obj?.name));
    //             setSelectedCategoryIds(category.map((obj) => obj?.id));
    //           } else {
    //             setSelectedCategory(prevSelected => {
    //               const selectedName = prevSelected?.[0];
    //               const existsInCategory = category?.some(p => p.name === selectedName);
    //               const newName = existsInCategory ? selectedName : category?.[0]?.name;
    //               return [newName];
    //             });
    //             setSelectedCategoryIds(prevSelected => {
    //               const selectedId = prevSelected?.[0];
    //               const existsInCategoryId = category?.some(p => p.id === selectedId);
    //               const newId = existsInCategoryId ? selectedId : category?.[0]?.id;
    //               return [newId];
    //             });
    //           }
    
    
    //         }
    //       }
    //     }
    
    //     fetchCustomerLlmsData();
    //   }, [selectedProductItems]);

    const handleCategoryCheckChange = (selected) => {
        if (!selected?.length) return;
        const names = selected.map((o) => o?.name ?? o?.categoryName ?? o);
        const latest = names[names.length - 1];
        setSelectedCategory([latest]);
    
          // Keep IDs in sync if options carry them
          const id =
              categories?.find((c) => c.name === latest)?.id ??
              selected?.find((s) => s?.id)?.id;
        if (id !== undefined) setSelectedCategoryIds([id]);
      };

  const shouldShowLoader = () => {
    const hasRequiredSelections =
      (selectedOptionShow === "Product"
        ? inputValidation.selectedProductItems
        : inputValidation.selectedBrandItems) &&
      inputValidation.selectedPersona &&
      inputValidation.selectedGeographyItems &&
      inputValidation.selectedMarketItems &&
      inputValidation.selectedCategory &&
      inputValidation.selectedLlmItems;

    return ((!showData && !isDone && hasRequiredSelections) || isFirstTime);
      };

  const getInputIds = () => {
    const brandId =
      brandItems?.filter((item) => item?.name === selectedBrandItems[0])[0]
        ?.id || null;

    const productId =
      productItems?.filter((item) => item?.name === selectedProductItems[0])[0]
        ?.id || null;

    const brandIds = brandItems
      ?.filter((item) => selectedBrandItems.includes(item?.name))
      .map((obj) => obj?.id);

    const productIds = productItems
      ?.filter((item) => selectedProductItems.includes(item?.name))
      .map((obj) => obj?.id);

    const globalLlmId = dbLlms?.filter(
      (item) => item?.name === selectedLlmItems[0]
    )[0]?.id;
    const marketId = markets?.filter(
      (item) => item?.name === selectedMarketItems[0]
    )[0]?.id;

    const geoId = geography?.filter(
      (item) => item?.name === selectedGeographyItems[0]
    )[0]?.id;

    const llmId = customerLlm?.filter(
      (item) =>
        item?.llm_id === globalLlmId &&
        item?.market_id === marketId &&
        item?.geography_id === geoId
    )[0]?.id;
    const personaId = personas
      ?.filter((item) => selectedPersona.includes(item?.name))
      .map((obj) => obj?.id);

    return {
      brandId,
      brandIds,
      productId,
      productIds,
      globalLlmId,
      llmId,
      personaId,
    };
  };

  const getCustomerLlmInputIds = () => {
    const llmIds = dbLlms
      .filter((item) => selectedLlmItems.includes(item?.name))
      .map((obj) => obj?.id);

    const marketIds = markets
      .filter((item) => selectedMarketItems.includes(item?.name))
      .map((obj) => obj?.id);

    const geoIds = geography
      .filter((item) => selectedGeographyItems.includes(item?.name))
      .map((obj) => obj?.id);

    const customerLlmIds = customerLlm
      .filter(
        (item) =>
          llmIds.includes(item?.llm_id) &&
          marketIds.includes(item?.market_id) &&
          geoIds.includes(item?.geography_id)
      )
      .map((obj) => obj?.id);

    return customerLlmIds;
  };

    const handleClickShow = async (isMetaRefresh) => {
        const error = handleInputValidation(
          selectedOptionShow,
          selectedBrandItems,
          selectedProductItems,
          selectedPersona,
          selectedFrequencyItems,
          value,
          selectedSubFrequencyItems,
          selectedLlmItems,
          selectedGeographyItems,
          selectedMarketItems,
          selectedCategory
        );
    
    
    
        if (error) {
          toast.error(error, {
            autoClose: 700,
          });
          return;
        }
      };

    const updateMonitoringDateList = async (brandId, productId, categoryIds, llmIds, personaIds, type) => {
        const payload = {
          productId, categoryIds, llmIds,
          personaIds, brandId, type, customerId, isCompanyUser
        }
        const dates = await getCustomerMonitoringDates(customerId, payload)
        // setAvailabelDates(selectedOptionShow === 'Product' ? dates?.productDates : dates?.brandDates)
        return selectedOptionShow === 'Product' ? dates?.productDates : dates?.brandDates
      }

  useEffect(() => {
      // setShowData(false);
      // setIsDone(false);
      const handler = setTimeout(async () => {
        if (selectedSubFrequencyItems === "Custom") {
          const customerLlmIds = getCustomerLlmInputIds();
          const { brandId, productId, personaId } = getInputIds();
          const dates = await updateMonitoringDateList(brandId, productId, selectedCategoryIds, customerLlmIds, personaId, selectedOptionShow)
          if (JSON.stringify(availableDates) === JSON.stringify(dates)) {
  
            handleClickShow()
          } else {
            setAvailableDates(dates)
          }
        } else {
          if (
            selectedPersona.length &&
            (selectedBrandItems.length || selectedProductItems.length) &&
            !isFirstTime
          ) {
  
            handleClickShow();
            setIsFilterQuery(false);
          }
        }
  
      }, 300);
  
      return () => clearTimeout(handler);
    }, [
      selectedPersona,
      selectedGeographyItems,
      selectedMarketItems,
      selectedLlmItems,
      selectedSubFrequencyItems,
      customDateFilter,
    selectedCategory,
    selectedOptionShow
    ]);

    const handleProductTabSelect = () => {
      // if (selectedOptionShow === "Product") {
        const defaultGeography = monitoringFiletrs?.products?.[0]?.customer_product_geo
        const geography = monitoringFiletrs?.products?.[0]?.categories?.[0]?.geographies;
        const markets = monitoringFiletrs?.products?.[0]?.categories?.[0]?.markets;
        const persona = monitoringFiletrs?.products?.[0]?.categories?.[0]?.personas;
        const llms = monitoringFiletrs?.products?.[0]?.categories?.[0]?.llms;
        const category = monitoringFiletrs?.products?.[0]?.categories?.map((item) => {
          return { id: item?.categoryId, name: item?.categoryName };
        });
        const categoryIds = [category?.[0]?.id] || null;
        const generalPersona = persona?.find(p => p.name === "General Persona");

        const brandProductId =
          monitoringFiletrs?.products?.[0]?.customer_brand_product_id || null;
        const personaId = [
          generalPersona?.id ||
          persona?.[0]?.id
        ];
        const globalLlmId = 1;
        const marketId = markets?.[0]?.id;
        const geoId = geography?.some(obj => obj.name === defaultGeography?.name) ? defaultGeography?.id : geography?.[0]?.id;
        const llmId = customerLlm?.filter(
          (item) =>
            item?.llm_id === globalLlmId &&
            item?.market_id === marketId &&
            item?.geography_id === geoId
        )[0]?.id;

        const productName = monitoringFiletrs?.products?.[0]?.product_name;
        // const generalPersona = persona?.find(p => p.name === "General Persona");


        setDbLlms(llms);
        setGeography(geography);
        setMarkets(markets);
        setSelectedProductItems([monitoringFiletrs?.products?.[0]?.product_name]);
        // setSelectedPersona([persona?.[0]?.name]);
        setSelectedPersona([
          generalPersona?.name || persona?.[0]?.name
        ]);
        setSelectedLlmItems(['gpt-4o']);
        setSelectedMarketItems([markets?.[0]?.name]);
        setSelectedGeographyItems([geography?.some(obj => obj.name === defaultGeography?.name) ? defaultGeography?.name : geography?.[0]?.name]);
        setProductItems(
          monitoringFiletrs?.products?.map((item) => {
            return {
              id: item?.customer_brand_product_id,
              name: item?.product_name,
            };
          })
        );
        setPersonas(persona);
        setCategories(category);
        setSelectedCategory([category?.[0]?.name]);
        setSelectedCategoryIds(categoryIds);
    }

    const handleBrandTabClick = () => {
      // if (selectedOptionShow === "Company/Brand") {
        const defaultGeography = monitoringFiletrs?.brands?.filter((item) =>
          selectedBrandItems.includes(item?.brand_name)
        )?.[0]?.customer_brand_geo
        const geography = monitoringFiletrs?.brands?.filter((item) =>
          selectedBrandItems.includes(item?.brand_name)
        )?.[0]?.categories?.[0]?.geographies;
        const markets = monitoringFiletrs?.brands?.filter((item) =>
          selectedBrandItems.includes(item?.brand_name)
        )?.[0]?.categories?.[0]?.markets;
        const persona = monitoringFiletrs?.brands?.filter((item) =>
          selectedBrandItems.includes(item?.brand_name)
        )?.[0]?.categories?.[0]?.personas;
        const llms = monitoringFiletrs?.brands?.filter((item) =>
          selectedBrandItems.includes(item?.brand_name)
        )?.[0]?.categories?.[0]?.llms;
        const category = monitoringFiletrs?.brands
          ?.filter((item) =>
            selectedBrandItems?.includes(item?.brand_name)
          )?.[0]
          ?.categories?.map((item) => {
            return { id: item?.categoryId, name: item?.categoryName };
          });
        const categoryIds = [category?.[0]?.id] || null;

        setDbLlms(llms);
        setGeography(geography);
        setMarkets(markets);
        setPersonas(persona);
        setCategories(category);
        // setSelectedLlmItems(['gpt-4o']);
        // setSelectedMarketItems([markets?.[0]?.name]);
        // setSelectedGeographyItems([geography?.some(obj => obj.name === defaultGeography?.name) ? defaultGeography?.name : geography?.[0]?.name]);
        setSelectedLlmItems(prevSelected => {
          const selectedName = prevSelected?.[0];
          const existsInLlms = llms?.some(p => p.name === selectedName);
          const newName = existsInLlms ? selectedName : "gpt-4o";
          return [newName]
        });
        setSelectedMarketItems(prevSelected => {
          const selectedName = prevSelected?.[0];
          const existsInMarkets = markets?.some(p => p.name === selectedName);
          const newName = existsInMarkets ? selectedName : markets?.[0]?.name;
          return [newName];
        });
        setSelectedGeographyItems(prevSelected => {
          const selectedName = prevSelected?.[0];

          if (geography?.some(g => g.name === selectedName)) {
            return [selectedName];
          }

          const fallbackName = geography?.some(g => g.name === defaultGeography?.name)
            ? defaultGeography?.name
            : geography?.[0]?.name;

          return [fallbackName];
        });

        setSelectedPersona(prevSelected => {
          const selectedName = prevSelected?.[0];
          const existsInPersona = persona?.some(p => p.name === selectedName);
          const newName = existsInPersona ? selectedName : persona?.[0]?.name;
          return [newName];
        });

        // setSelectedCategory([category?.[0]?.name]);
        // setSelectedCategoryIds(categoryIds);

        const isCategoryTab = activeTab === "category";
        if (isCategoryTab) {
          setSelectedCategory(category.map((obj) => obj?.name));
          setSelectedCategoryIds(category.map((obj) => obj?.id));
        } else {
          setSelectedCategory(prevSelected => {
            const selectedName = prevSelected?.[0];
            const existsInCategory = category?.some(p => p.name === selectedName);
            const newName = existsInCategory ? selectedName : category?.[0]?.name;
            return [newName];
          });
          setSelectedCategoryIds(prevSelected => {
            const selectedId = prevSelected?.[0];
            const existsInCategoryId = category?.some(p => p.id === selectedId);
            const newId = existsInCategoryId ? selectedId : category?.[0]?.id;
            return [newId];
          });
        }
      // }
    }
    

  const handleDragEnd = (result) => {
    if (!result.destination) return; // If dropped outside the list, do nothing

    const { source, destination } = result;

    // Find the parent container (sequence) of the dragged item
    const updatedSequence = [...activeSequence];

    const parentIndex = updatedSequence.findIndex((seq) =>
      seq.config.some((item) => String(item.id) === result.draggableId)
    );

    if (parentIndex === -1) return; // No valid parent found

    // Clone the config array of the identified sequence
    const updatedConfig = Array.from(updatedSequence[parentIndex].config);

    // Reorder the dragged item within its sequence
    const [movedItem] = updatedConfig.splice(source.index, 1);
    updatedConfig.splice(destination.index, 0, movedItem);

    // Update the sequence with the new config order
    updatedSequence[parentIndex] = {
      ...updatedSequence[parentIndex],
      config: updatedConfig,
    };

    setActiveSequence(updatedSequence); // Update the state with new order
  };

  const handleEnableDisable = (sectionId, itemId) => {
    setActiveSequence((prevConfigs) =>
      prevConfigs.map((section) => {
        if (section.id === sectionId) {
          return {
            ...section,
            config: section.config.map((item) =>
              item.id === itemId
                ? { ...item, is_active: !item.is_active }
                : item
            ),
          };
        }
        return section;
      })
    );
  };

  const handleSwitchChange = (sectionId, itemId, type = "summary") => {
    setActiveSequence((prevConfigs) =>
      prevConfigs.map((section) => {
        if (section.id === sectionId) {
          return type === "summary"
            ? {
              ...section,
              config: section.config.map((item) =>
                item.id === itemId
                  ? { ...item, generate_summary: !item.generate_summary }
                  : item
              ),
            }
            : {
              ...section,
              config: section.config.map((item) =>
                item.id === itemId
                  ? { ...item, show_change: !item.show_change }
                  : item
              ),
            };
        }
        return section;
      })
    );
  };

  const handleProductCheckChange = (selected) => {
    // let selectedValues = selected?.map((option) => option?.product?.name);
    let selectedValues = selected?.map((option) => option?.name);
    let lastIndex = selectedValues.length - 1;
    selectedValues = selectedValues?.filter(
      (item, index) => index === lastIndex
    );
    const latestValue = selectedValues[0];
    setSelectedProductItems(selectedValues || []);
    // setSelectedPersona([]);
    // const selectedProduct = brandProducts?.data?.data.filter(
    //   (data) => data?.product?.name === latestValue && data?.is_active
    // );

    // const persona = selectedProduct[0]?.custProduct;
    // setPersonas(persona);

    // personas/others will be derived by the recompute effect from monitoringFiletrs
    setSelectedPersona([]);
  };

  const handleBrandCheckChange = (selected) => {
    console.log("handleBrandCheckChange selected", selected);
    let selectedValues = selected?.map((option) => option?.name);
    let lastIndex = selectedValues.length - 1;
    console.log("before selectedValues", selectedValues);
    selectedValues = selectedValues?.filter(
      (item, index) => index === lastIndex
    );
    console.log("after selectedValues", selectedValues);
    const latestValue = selectedValues[0];

    setSelectedBrandItems(selectedValues || []);
    const selectedBrand = brands?.data?.data.filter(
      (data) => data?.brand?.name === latestValue && data?.is_active
    );
    const persona = selectedBrand[0]?.persona;
    setPersonas(persona);
  };

  const handlePersonaCheckChange = (selected) => {
    if (!selected.length) return;
    const selectedValues = selected?.map((option) => option?.name);
    const latestValue = selectedValues[selectedValues.length - 1];
    setSelectedPersona([latestValue] || []);
  };

  const handleGeographyCheckChange = async (selected) => {
    if (!selected.length) return;
    let selectedValues = selected?.map((option) => option?.name);
    const latestValue = selectedValues[selectedValues.length - 1];
    setSelectedGeographyItems([latestValue] || []);

    let geoId = geography.filter((obj) => obj?.name === latestValue)[0]?.id;
    let market = await getMarkets();
    const filtercustomeLlm = customerLlm.filter(
      (obj) => obj?.geography_id === geoId
    );

    if (selectedValues && selectedValues.length === 1) {
      // set customer geography markets

      const marketIds = [
        ...new Set(filtercustomeLlm.map((obj) => obj?.market_id)),
      ];
      market = market?.data.filter((obj) => marketIds.includes(obj?.id));
      setMarkets(market);
    } else if (selectedValues && selectedValues.length > 1) {
      // set customer geography markets

      market = market?.data.filter((obj) => obj?.name === "General Market");
      setMarkets(market);
    }
  };

  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
  };


  const handlesubFrequencyCheckChange = (key) => {
    setSelectedSubFrequencyItems(key);
  };

  const handleMarketCheckChange = (selected) => {
    let selectedValues = selected?.map((option) => option?.name);

    setSelectedMarketItems(selectedValues || []);
  };

  const handleLlmCheckChange = (selected) => {
    if (!selected.length) return;
    const index = selected.length - 1;
    const selectedValues = [selected[index].name] || [];
    setSelectedLlmItems(selectedValues || []);
  };

  const handleSubmitReporting = async () => {
    let interval;
    try {
      setLoading(true);
      const frontend_build_version = localStorage.getItem(
        "frontend_build_version"
      );
      const token = localStorage.getItem("token");
      const user = localStorage.getItem("user");
      const overview =
        activeSequence.find((o) => o.id === "overview")?.config || [];
      const category = activeSequence.find((o) => o.id === "category")?.config || [];
      const competition =
        activeSequence.find((o) => o.id === "competition")?.config || [];
      const llm = activeSequence.find((o) => o.id === "llm")?.config || [];
      const market =
        activeSequence.find((o) => o.id === "market")?.config || [];
      const persona =
        activeSequence.find((o) => o.id === "persona")?.config || [];

      const source =
        activeSequence.find((o) => o.id === "source")?.config || [];

      const payload = {
        brand: selectedOptionShow === "Product" ? selectedProductItems?.[0] : selectedBrandItems?.[0],
        reporting_config: {
          overview,
          category,
          competition,
          llm,
          market,
          persona,
          source,
        },
        filter_config: {
          is_brand: selectedOptionShow !== "Product",
          llm: MONITORING_LLM_LABELS[selectedLlmItems?.[0]] || selectedLlmItems?.[0],
          market: selectedMarketItems?.[0],
          persona: selectedPersona?.[0],
          brand: selectedBrandItems?.[0],
          product: selectedProductItems?.[0],
          geography: selectedGeographyItems?.[0],
          category: selectedCategory?.[0],
          brand_product_name:
            selectedOptionShow === "Product"
              ? selectedProductItems?.[0]
              : selectedBrandItems?.[0],
          frequency: selectedSubFrequencyItems,
          showChangeData: isChecked,
        },
        frontend_build_version,
        token,
        user,
      };
      console.log(payload);
      // Start Mock Progress
      let progress = 0;
      interval = setInterval(() => {
        if (progress >= 99) {
          clearInterval(interval);
          return;
        }
        progress += 1; // Increase by 5% per second
        setPercentCompleted(progress);
      }, 1000);
      const blob = await api.post("/llm-reporting/generate", payload, {
        responseType: "blob",
      });
      const url = window.URL.createObjectURL(blob.data);
      const a = document.createElement("a");
      a.href = url;
      a.download = "reporting.pptx";
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      setLoading(false);
    } catch (error) {
      console.log(error);
    } finally {
      setPercentCompleted(0);
      setLoading(false);
      clearInterval(interval);
    }
  };

  return (
    <div className="p-4 max-w-lg mx-auto">
      <nav className="customTabs">
        <div className="nav nav-tabs" id="nav-tab" role="tablist">
          <button
            className={`nav-link ${selectedOptionShow === "Company/Brand" ? "active" : ""
              }`}
            id="nav-configuration-tab"
            data-bs-toggle="tab"
            data-bs-target="#nav-configuration"
            type="button"
            role="tab"
            aria-controls="nav-home"
            aria-selected={selectedOptionShow === "Company/Brand"}
            onClick={() => {
              if(selectedOptionShow !== "Company/Brand") {

                setSelectedOptionShow((prev) => "Company/Brand")
                setActiveSequence(initialBrandTabs);
                setSelectedBrandItems([brandItems[0]?.name]);
                handleBrandTabClick();
              }
            }}
          >
            Brand
          </button>
          <button
            className={`nav-link ${selectedOptionShow === "Product" ? "active" : ""
              }`}
            id="nav-configuration-tab"
            data-bs-toggle="tab"
            data-bs-target="#nav-configuration"
            type="button"
            role="tab"
            aria-controls="nav-home"
            aria-selected={selectedOptionShow === "Product"}
            onClick={() => {
              if(selectedOptionShow !== "Product") {

                setSelectedOptionShow((prev) => "Product")
                setActiveSequence(initialProdTabs);
                setSelectedProductItems([productItems[0]?.name]);
                handleProductTabSelect();
              }
            }}
          >
            Product
          </button>
        </div>
      </nav>
      <DashboardNav
        activeTab={activeTab}
        handleTabClick={handleTabClick} 
        selectedOptionShow={selectedOptionShow}
        brandItems={brandItems}
        selectedBrandItems={selectedBrandItems}
        handleBrandCheckChange={handleBrandCheckChange}
        handleProductCheckChange={handleProductCheckChange}
        selectedProductItems={selectedProductItems}
        productItems={productItems}
        inputValidation={inputValidation}
        isFirstTime={!!isFirstTime}
        selectedPersona={selectedPersona}
        handlePersonaCheckChange={handlePersonaCheckChange}
        personas={personas}
        handleCategoryCheckChange={handleCategoryCheckChange}
        selectedCategory={selectedCategory}
        categories={categories}
        selectedGeographyItems={selectedGeographyItems}
        handleGeographyCheckChange={handleGeographyCheckChange}
        geography={geography}
        selectedMarketItems={selectedMarketItems}
        handleMarketCheckChange={handleMarketCheckChange}
        markets={markets}
        selectedLlmItems={selectedLlmItems}
        handleLlmCheckChange={handleLlmCheckChange}
        dbLlms={dbLlms}
        selectedSubFrequencyItems={selectedSubFrequencyItems}
        handlesubFrequencyCheckChange={handlesubFrequencyCheckChange}
        showData={isReady()}
        // isDone={true}
        isDone={isReady()}
        handleClickShow={() => {
          handleSubmitReporting();
        }}
        isReporting={true}
        // showFilterModal={false}
        // filterModalType={"NA"}
        // setShowFilterModal={false}
        endDate={endDate}
        setEndDate={setEndDate}
              startDate={startDate}
              setStartDate={setStartDate}
              availableDates={availableDates}
              setCustomDatesToDisplay={setCustomDatesToDisplay}
      
              // Filter modal props (hooked up to real state)
              showFilterModal={showFilterModal}
              filterModalType={filterModalType}
              setShowFilterModal={setShowFilterModal}
        handleFilterItemSelect={() => { }}
        handleFilterMenuSelect={() => { }}
        isFilterActive={isFilterActive}
        showNav={false}
      />
      <div style={{ padding: "10px 10px 10px 5px" }}>
        <Typography variant="caption">
          Note: By default all dashboards are enabled for report generation
        </Typography>
      </div>
      <div style={{ fontSize: "15px", marginLeft: '10px', marginBottom: '10px' }}>
        <label>
          <input
            style={{}}
            type="checkbox"
            checked={isChecked}
            onChange={handleCheckboxChange}
          />
          &nbsp;
          {"Show Change Data"}
        </label>
      </div>
      <div>
        {shouldShowLoader() && (
          <div
            style={{
              fontSize: "19px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginTop: "20px",
              color: "green",
            }}
          >
            <Spinner
              as="span"
              animation="grow"
              size="sm"
              role="status"
              aria-hidden="true"
            />
            Please Wait...
          </div>
        )}
        {isLoading || shouldShowLoader() ||
          ((selectedOptionShow === "Product"
            ? !inputValidation.selectedProductItems
            : !inputValidation.selectedBrandItems) &&
            !inputValidation.selectedPersona &&
            !inputValidation.selectedGeographyItems &&
            !inputValidation.selectedMarketItems &&
            !inputValidation.selectedLlmItems) ? (
          <>
            {percentCompleted > 0 && (
              <Typography variant="h6">{`Downloading ${percentCompleted}%`}</Typography>
            )}
            <BorderLinearProgress
              variant="determinate"
              value={percentCompleted}
            />
            {Array.from({ length: 5 }).map((_, id) => (
              <Skeleton
                key={id}
                sx={{ fontSize: "30px", marginVertical: "8px" }}
              />
            ))}
          </>
        ) : (
          <>
            {activeSequence.length > 0 && (
              <div className={classes.columns_container}>
                {activeSequence.map(({ id, label, config }) => (
                  <div key={id} className={classes.each_column}>
                    <Typography
                      variant="body2"
                      style={{ fontWeight: "bold", fontSize: "12px" }}
                    >
                      {label}
                    </Typography>

                    <DragDropContext onDragEnd={handleDragEnd}>
                      <Droppable droppableId={`droppable-list-${id}`}>
                        {(provided) => (
                          <div
                            ref={provided.innerRef}
                            {...provided.droppableProps}
                            className={classes.each_subrow_container}
                          >
                            {config.map((item, index) => (
                              <Draggable
                                key={item.id}
                                draggableId={String(item.id)}
                                index={index}
                              >
                                {(provided) => (
                                  <div
                                    ref={provided.innerRef}
                                    {...provided.draggableProps}
                                    {...provided.dragHandleProps}
                                    style={{
                                      opacity: item.is_active ? 1 : 0.5,
                                      background: item.is_active
                                        ? "#E3F2FD"
                                        : "#F5F5F5",
                                      borderLeft: item.is_active
                                        ? "4px solid #007BFF"
                                        : "4px solid #B0BEC5",
                                      ...provided.draggableProps.style, // Ensures smooth dragging
                                    }}
                                    className={classes.each_subrow}
                                    onClick={() =>
                                      handleEnableDisable(id, item.id)
                                    }
                                  >
                                    <ListItemText
                                      primary={item.name}
                                      primaryTypographyProps={{
                                        variant: "caption",
                                      }}
                                    />
                                    {item.generate_summary !== undefined && (
                                      <div onClick={(e) => e.stopPropagation()}>
                                        <Typography
                                          variant="caption"
                                          style={{
                                            fontSize: "10px",
                                            color: "grey",
                                          }}
                                        >
                                          Summary:
                                        </Typography>
                                        <Switch
                                          size="small"
                                          sx={{ transform: "scale(0.8)" }}
                                          checked={item.generate_summary}
                                          onChange={(e) => {
                                            e.stopPropagation();
                                            handleSwitchChange(id, item.id);
                                          }}
                                        />
                                      </div>
                                    )}
                                    {item.show_change !== undefined && (
                                      <div onClick={(e) => e.stopPropagation()}>
                                        <Typography
                                          variant="caption"
                                          style={{
                                            fontSize: "10px",
                                            color: "grey",
                                          }}
                                        >
                                          Show Change:
                                        </Typography>
                                        <Switch
                                          size="small"
                                          sx={{
                                            transform: "scale(0.8)",
                                          }}
                                          checked={item.show_change}
                                          onChange={(e) => {
                                            e.stopPropagation();
                                            handleSwitchChange(
                                              id,
                                              item.id,
                                              "change"
                                            );
                                          }}
                                        />
                                      </div>
                                    )}
                                  </div>
                                )}
                              </Draggable>
                            ))}
                            {provided.placeholder}
                          </div>
                        )}
                      </Droppable>
                    </DragDropContext>
                  </div>
                ))}
              </div>
            )}
          </>
        )}
      </div>
      <ToastContainer />
    </div>
  );
}
